export default __webpack_public_path__ + "i18n/translations/translation-kn.d6b2f8f4.json";